export const testSuitesQueryKeys = {
  detectedRisks: (params: { teamId: string }) =>
    ['test-suites/detected-risks', params] as const,
  testSuite: (testSuiteId: string, params: { teamId: string }) =>
    [testSuiteId ? `test-suites/${testSuiteId}` : undefined, params] as const
}
